import React from "react";


/**
 * Componente que muestra los botones de paginación, las props que recibe son las funciones que se retornan en el hook de usePagination;
 * @param {{onClickPrev:Function, onClickNext:Function, onClickPage:Function, currentPage:number, totalPages:number, range:Array<number|string>}} props
 * @prop {Function} onClickPrev - Funci n que se ejecuta al hacer clic en el bot n de "Anterior".
 * @prop {Function} onClickNext - Funci n que se ejecuta al hacer clic en el bot n de "Siguiente".
 * @prop {Function} onClickPage - Funci n que se ejecuta al hacer clic en un n mero de p gina.
 * @prop {number} currentPage - N mero de la p gina actual.
 * @prop {number} totalPages - N mero total de p ginas.
 * @prop {Array<number|string>} range - Arreglo que contiene los n meros de p gina a mostrar.
 * @returns {JSX.Element} Elemento JSX que representa los botones de paginaci n.
 */
export const PaginationControls = ({
	onClickPrev,
	onClickNext,
	onClickPage,
	currentPage,
	totalPages,
	range,
}) => {
	const handlePrevClick = () => {
		onClickPrev && onClickPrev();
	};
	const handleNextClick = () => {
		onClickNext && onClickNext();
	};

	const handlePageClick = (page) => {
		onClickPage && onClickPage(page);
	};

	const iconSize = 12;

	const rangeButtons = () => {
		return (
			<div className="d-flex justify-center align-items-center">
				{range.map((page, i) => (
					<button
						className={`focusable-red pagination-button ${
							page === "..." ? "ellipsis" : ""
						}  ${page === currentPage ? "selected" : ""}`}
						key={i}
						onClick={() => handlePageClick(page)}
						disabled={page === "..." ? true : false}
					>
						{page}
					</button>
				))}
			</div>
		);
	};

	return (
		<div className="default-pagination-controls w-100 d-flex flex-column flex-md-row">
			<div className="sm-mobile-range-buttons">{rangeButtons()}</div>
			<div className="w-100 d-flex justify-content-between justify-content-center my-2">
				<button
					className="pagination-button nav-button focusable-red"
					onClick={() => handlePrevClick()}
					aria-label="Previous/Anterior"
					disabled={currentPage === 1 ? true : false}
				>
					<svg
						width={iconSize}
						viewBox="0 0 8 13"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M6.5 1.5L1.5 6.5L6.5 11.5"
							stroke="currentColor"
							stroke-width="2.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
				</button>
				<div className="range-buttons">{rangeButtons()}</div>

				<button
					className="pagination-button nav-button focusable-red"
					onClick={() => handleNextClick()}
					aria-label="Next/Siguiente"
					disabled={currentPage === totalPages}
				>
					<svg
						width={iconSize}
						viewBox="0 0 9 14"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M2 12L7 7L2 2"
							stroke="currentColor"
							stroke-width="2.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
				</button>
			</div>
		</div>
	);
};
